import Http from '../http'

export default {

  index(params) {
    console.log(params)
    return Http.get(`/executions`, {
      params: {
        ...params
      }
    })
  },

  indexByModel({model, model_id}) {
    return Http.get(`${model}/${model_id}/executions`)
  },

  create(execution){
    return Http.post(`/executions`, {
      execution: {
      ...execution,
      }
    })
  },

  update(execution){
    return Http.put(`/executions/${execution.id}`, {
      execution: {
        ...execution,
      },
    });
  },

  show(id) {
    return Http.get(`/executions/${id}`);
  },

  delete(id){
    return Http.delete(`/executions/${id}`)
  }

}
